import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface CountrySelectionProps {
  countryName: string;
  countryFlagPath: string;
  countryPath: string;
}

const cardBaseClasses =
  "transition duration-100 ease-in-out flex flex-col items-center pt-7 pb-7 rounded-3xl";
const cardSelectedClasses = "border-2 border-[#837EF9] bg-[#D7D6F7]";
const cardNotSelectedClasses = "bg-white";

const CountrySelection: React.FC<CountrySelectionProps> = ({
  countryName,
  countryFlagPath,
  countryPath,
}) => {
  const [isSelected, setSelected] = useState(false);
  useEffect(() => {
    document.addEventListener("dragend", () => {
      setSelected(false);
    });
  }, []);

  const cardClasses = `${cardBaseClasses} ${isSelected ? cardSelectedClasses : cardNotSelectedClasses}`;

  return (
    <Link
      onDragStart={() => setSelected(false)}
      to={"/" + countryPath}
      preventScrollReset={false}
    >
      <div onMouseDown={() => setSelected(true)} className={cardClasses}>
        <img
          onDragStart={() => setSelected(false)}
          className="rounded-2xl mb-5"
          src={countryFlagPath}
          alt="Germany"
        />
        <p className="px-1 text-center">{countryName}</p>
      </div>
    </Link>
  );
};

export default CountrySelection;
